








































































import {
  defineComponent,
  computed,
  ref,
  onMounted,
  onUnmounted,
  watch
} from '@nuxtjs/composition-api'
import BlkButton from '@/components/balko-ui/BlkButton.vue'
import BlkQrPixCode from '../BlkQrPixCode.vue'
import BlkIncreaseButton from '../BlkIncreaseButton.vue'

interface propsType {
  minInvestValue: number
  maxInvestValue: number
  title: string
  offerName: string
}

export default defineComponent({
  components: {
    BlkButton,
    BlkQrPixCode,
    BlkIncreaseButton
  },
  props: {
    minInvestValue: Number,
    maxInvestValue: Number,
    title: String,
    offerName: String
  },
  emits: ['closeInvestModa'],
  setup(props: propsType) {
    let reactiveValue: any = ref(
      props.minInvestValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/gi, '$1.')
    )

    const lockScreenScroll = () => {
      if (window) {
        window.scrollTo(0, 0)
      }
      if (document) {
        document.body.classList.add('modal-open')
      }
    }

    const unlockScreenScroll = () => {
      if (document) {
        document.body.classList.remove('modal-open')
      }
    }

    onMounted(lockScreenScroll)
    onUnmounted(unlockScreenScroll)

    const increaseValue = () => {
      reactiveValue.value = reactiveValue.value.replace('.', '')
      reactiveValue.value = parseInt(reactiveValue.value)
      if (reactiveValue.value < props.maxInvestValue)
        reactiveValue.value += props.minInvestValue
    }
    const decreaseValue = () => {
      reactiveValue.value = reactiveValue.value.replace('.', '')
      reactiveValue.value = parseInt(reactiveValue.value)
      if (reactiveValue.value > props.minInvestValue)
        reactiveValue.value -= props.minInvestValue
    }
    const validateValue = () => {
      if (reactiveValue.value === '') {
        reactiveValue.value = props.minInvestValue.toString()
      }
      reactiveValue.value = reactiveValue.value.replace('.', '')
      reactiveValue.value = parseInt(reactiveValue.value)
      if (reactiveValue.value < props.minInvestValue) {
        reactiveValue.value = props.minInvestValue.toString()
      }

      if (reactiveValue.value > props.maxInvestValue) {
        reactiveValue.value = props.maxInvestValue.toString()
      }

      if (reactiveValue.value % props.minInvestValue !== 0) {
        reactiveValue.value =
          Math.floor(reactiveValue.value / props.minInvestValue) *
          props.minInvestValue
      }
    }

    watch(reactiveValue, () => {
      reactiveValue.value = reactiveValue.value.toString()
      reactiveValue.value = reactiveValue.value.replace(/([^0-9:/])/gi, '')
      reactiveValue.value = reactiveValue.value
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/gi, '$1.')
    })

    return {
      increaseValue,
      decreaseValue,
      reactiveValue,
      validateValue
    }
  }
})
